export async function subscriptionQuery({ client, subscriptionId }) {
  const { data } = await client.get(`subscriptions/${subscriptionId}/`);
  return data;
}
